import {closeAiActionLoadingModal, isCurrentModalSession, openShareLoadingModalAndGetSessionId} from '@Components/ai-chat-window/lib/ai-action-loading-modal.library';
import {getPosterHashedIdForAiChatImageAsset} from '@Components/ai-chat-window/lib/chat-attachment-image.library';
import {openSharingModal} from '@Modals/share-modal/share-modal-library';
import {SHARE_PANEL_ID, ShareItemType} from '@Panels/share-panel/share-panel.types';

export async function shareAiChatImage(imageHashedId: string): Promise<void> {
  const sessionId = openShareLoadingModalAndGetSessionId();

  try {
    const posterHashedId = await getPosterHashedIdForAiChatImageAsset(imageHashedId);

    if (!isCurrentModalSession(sessionId)) {
      return;
    }

    openSharingModal({itemHashedId: posterHashedId, type: ShareItemType.POSTER, panelId: SHARE_PANEL_ID});
  } catch (e: unknown) {
    console.error(e);
  } finally {
    if (isCurrentModalSession(sessionId)) {
      closeAiActionLoadingModal();
    }
  }
}
